import React from "react";
import styled from "styled-components";
import AvatarDefault from "../../Assets/images/webinar.png";
const NotiBox = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 10px 0;
  background-color: #504de5;
  h3 {
    font-size: 1.1rem;
    font-weight: bold;
    color: #ffffff;
    margin: 0 15.5px;
  }
  > a {
    padding: 3px 19px 3px 18px;
    border-radius: 3px;
    background-color: #f7b01a;
    font-weight: bold;
    color: #453209;
    font-size: 1rem;
  }
  @media (max-width: 768px) {
    h3 {
      font-size: 0.9rem;
    }
    a {
      font-size: 0.9rem;
    }
  }
  @media (max-width: 400px) {
    h3 {
      font-size: 0.7rem;
    }
    a {
      font-size: 0.7rem;
    }
  }
`;

const ImageBox = styled.div`
  @media (max-width: 440px) {
    display: none;
  }
`;

const NotificationBar = () => {
  return (
    <NotiBox>
      <ImageBox>
        <img
          src={AvatarDefault}
          alt="وبینار آشنایی با رایتینگ تسک 2 آیلتس"
          width={35}
          height={35}
        />
      </ImageBox>
      <h3>وبینار آشنایی با رایتینگ تسک 2 آیلتس</h3>
      <a href="https://yun.ir/8bwzwb" target="_blank" rel="nofollow">
        ثبت نام
      </a>
    </NotiBox>
  );
};

export default NotificationBar;
